import { Popper, TextField } from "@material-ui/core";
import { Autocomplete, AutocompleteRenderInputParams } from "@material-ui/lab";
import { RxSelectBoxItemObject } from "../RxSelectBox/RxSelectBox";

interface RxAutoCompleteProps {
	name: string;
	options: RxSelectBoxItemObject[];
	disableClearable?: boolean;
	disabled?: boolean;
	handleSelectChange?: (event: any, newValue: RxSelectBoxItemObject) => void;
	inputLabel?: string;
	required?: boolean;
	noOptionsText?: string;
	defaultValue?: any;
}
const RxAutoComplete = (props: RxAutoCompleteProps) => {
	const popperComponent = (props: any) => {
		return (
			<Popper
				{...props}
				style={{ width: "fit-content" }}
				placement="bottom-start"
			/>
		);
	};
	return (
		<Autocomplete
			autoSelect
			autoComplete
			id={props.name}
			options={props.options}
			disabled={props.disabled}
			PopperComponent={popperComponent}
			defaultValue={props.defaultValue}
			onChange={props.handleSelectChange}
			getOptionLabel={(option: any) => option.label}
			disableClearable={props.disableClearable ?? true}
			noOptionsText={props.noOptionsText ?? "Seçenek bulunamadı"}
			getOptionSelected={(option, value) => option.value === value.value}
			renderInput={(params: AutocompleteRenderInputParams) => {
				return (
					<TextField
						name={props.name}
						{...params}
						label={props.inputLabel}
						required={props.required}
					/>
				);
			}}
		/>
	);
};

export default RxAutoComplete;
